<p>consent-form works!</p>

@if (resourceDef) {
<dhs-form [fieldGroup]="resourceDef.form" [config]="config" [action]="'ADD'"  [data]="_currentData"
    (questionValueChanged)="questionValueChanged($event)" (cancel)="cancelButtonClick()"> 
</dhs-form>
}